import { connect, ConnectedProps } from 'react-redux';

import { RootState } from 'src/redux/store';
import { selectors as sessionSelectors } from 'src/redux/data/sessions';
import { UUID } from 'src/types/utility';
import { displayInTimezone, FORMAT_WITHOUT_SECONDS } from 'src/utils/timeUtils';
import dayjs from 'dayjs';
import { API_STATUS } from 'src/utils/api-constants';
import {
  actions as siteGroupsDataActions,
  selectors as siteGroupsDataSelectors,
} from 'src/redux/data/siteGroups';
import { selectors as loggedInUserSelectors } from 'src/redux/data/loggedInUser';

type OwnProps = {
  groupId: UUID;
};

const mapStateToProps = (state: RootState, { groupId }: OwnProps) => {
  const devicesDisconnectionOverview =
    siteGroupsDataSelectors.selectSiteGroupDisconnectionOverview(
      state,
      groupId,
    );
  const timezone = loggedInUserSelectors.getUserTenantTimezone(state);
  const deviceDisconnectionTableItems = devicesDisconnectionOverview.map(
    device => {
      return {
        ...device,
        key: device.manufacturerId,
        deviceId: device.manufacturerId,
        groupId,
        deviceStatus: device.patientAssignmentStatus,
        lastConnectionTime:
          device.lastConnectedAt &&
          dayjs(device.lastConnectedAt).utc(true).unix()
            ? displayInTimezone(
                device.lastConnectedAt,
                timezone,
                FORMAT_WITHOUT_SECONDS,
              )
            : 'N/A',
      };
    },
  );

  const isDataLoading =
    siteGroupsDataSelectors.selectSiteGroupDisconnectionStatus(state) ===
    API_STATUS.LOADING;

  return {
    deviceDisconnectionTableItems,
    sessions: sessionSelectors.selectSessions(state),
    devicesDisconnectionOverviewMetadata:
      siteGroupsDataSelectors.selectSiteGroupDisconnectionMetadata(
        state,
        groupId,
      ),
    isDataLoading,
  };
};

const mapActionCreators = {
  fetchSiteGroupDisconnectionOverview:
    siteGroupsDataActions.fetchSiteGroupDisconnectionOverview,
};

const Connector = connect(mapStateToProps, mapActionCreators);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export type IProps = OwnProps & PropsFromRedux;

export default Connector;
